







<nav class="navbar navbar-expand-lg navbar-light  py-0  " style="background-color: #132a42;">
    <!-- Hamburger for Mobile (Hidden on Desktop) -->
    <button class="navbar-toggler ml-1" style="outline: none!important; box-shadow: none;; z-index: 1000000000;" type="button" (click)="toggleSidebar()" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <!-- Logo (Centered on Mobile, Left on Desktop) -->
    <a class="navbar-brand mx-auto mx-lg-2 py-2  "  href="#">    <img src="./assets/logo50.png"   alt="Logo" class="logo-img w-100 h-25 ">
    </a>
  
    <!-- User Settings (Dropdown on Mobile, Horizontal Menu on Desktop) -->

        
  <!-- User Settings (Icon with 3-dot menu on Desktop) -->
  <div class="user-settings ml-auto d-none d-lg-block">
   <div class="d-flex justify-content-around">
    <div class="d-flex flex-end">

      <!--<li class="nav-item dropdown d-flex notifications">
        <a
          class="nav-link icon caret position-relative"
          href="#"
          id="notificationDropdown"
          role="button"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="far fa-bell fa-2x pt-1 m-2"></i>
          <span class="pulse1 bg-success"></span>
        </a>
        <ul
          class="dropdown-menu dropdown-menu-right dropdown-menu-arrow shadow-lg"
          aria-labelledby="notificationDropdown"
          style="min-width: 300px; font-family: 'Poppins', sans-serif;"
        >
          <li class="p-4 border-bottom">
            <h5 class="mb-0 fl-16 fw-semibold">Notifications</h5>
          </li>
          <li class="notifications-menu">
            <a class="dropdown-item d-flex align-items-center text-white" href="/apps/mails/mail-inbox">
              <div class="mr-3 p-2 notifyimg bg-primary rounded-circle ">
                <i data-feather="mail"></i>
              </div>
              <div>
                <h6 class="notification-label mb-0 text-wrap">Commented on your post</h6>
                <span class="notification-subtext text-muted fl-12">3 days ago</span>
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="/apps/mails/mail-inbox">
              <div class="mr-3 p-2 notifyimg bg-secondary rounded-circle">
                <i data-feather="download"></i>
              </div>
              <div>
                <h6 class="notification-label mb-0 text-wrap">New file has been uploaded</h6>
                <span class="notification-subtext text-muted fl-12">3 days ago</span>
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="/apps/mails/mail-inbox">
              <div class="mr-3 p-2 notifyimg bg-warning rounded-circle">
                <i class="fe fe-user"></i>
              </div>
              <div>
                <h6 class="notification-label mb-0 text-wrap">User account has been updated</h6>
                <span class="notification-subtext text-muted fl-12">2 days ago</span>
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="/apps/mails/mail-inbox">
              <div class="mr-3 p-2 notifyimg bg-danger rounded-circle">
                <i class="fe fe-shopping-cart"></i>
              </div>
              <div>
                <h6 class="notification-label mb-0 text-wrap">New order received</h6>
                <span class="notification-subtext text-muted fl-12">1 hour ago</span>
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="/apps/mails/mail-inbox">
              <div class="mr-3 p-2 notifyimg bg-info rounded-circle">
                <i class="fe fe-server"></i>
              </div>
              <div>
                <h6 class="notification-label mb-0 text-wrap">Server rebooted</h6>
                <span class="notification-subtext text-muted fl-12">2 hours ago</span>
              </div>
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <a
              href="/apps/mails/mail-inbox"
              class="dropdown-item text-center pt-2 mb-2"
            >View all Notifications</a>
          </li>
        </ul>
      </li>-->


      <div *ngIf="showPopup" id="notification-popup" class="notification-popup" [ngClass]="{'show': showPopup}">
         
        <div>
          <h6 class="notification-label mb-0 text-wrap">{{ latestNotification.message }}</h6>
          <span class="notification-subtext text-muted fs-12">{{latestNotification.created_at | date}}</span>
         
        </div>
      </div>
      <li class="nav-item dropdown d-flex notifications">
        <a
          class="nav-link icon caret position-relative"
          href="#"
          id="notificationDropdown"
          role="button"
          data-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside" 
        >
        <div class="m-2 position-relative">
          <i class="far fa-bell fa-2x pt-1  text-white"></i>
          <span class="badge rounded-pill bg-danger position-absolute top-0 start-100 translate-middle text-white" *ngIf="unreadCount > 0">
            {{ unreadCount }}
          </span>
        </div>
          <span class="pulse1 bg-success"></span>
        </a>
    <ul
    class="dropdown-menu dropdown-menu-right dropdown-menu-arrow shadow-lg"
    aria-labelledby="notificationDropdown"
    style="min-width: 300px; font-family: 'Poppins', sans-serif;"
  >
    <li class="p-3 border-bottom">
      <label class="mb-0 fs-10 fw-semibold" ><strong>Notifications</strong></label>
    </li>
    <li class="notifications-menu" *ngFor="let notification of (showAllNotifications ? notifications : (notifications | slice:0:3)); let i = index">
      <a class="dropdown-item d-flex align-items-center" href="#">
        <div class="mr-3  p-2 notifyimg bg-primary rounded-circle text-white">
          <i data-feather="bell" ></i>
         
        </div>
        <div>
          <h6 class="notification-label mb-0 text-wrap">{{ notification.message }}</h6>
          <span class="notification-subtext text-muted fl-12">{{notification.created_at | date}}</span>
          <button class="btn btn-sm btn-link text-danger flex-end" (click)="dismissNotification(notification.pid, i)">Dismiss</button>
        </div>
      </a>
      <hr class="m-0">
    </li>
    <li>
      <a
      class="dropdown-item text-center pt-2 mb-2"
      (click)="toggleShowAll()"
    >
      {{ showAllNotifications ? 'Show Less' : 'View All Notifications' }}
    </a>
    </li>
  </ul>

  
</li>


        </div>

        <div class="dropdown pt-2 m-2">
          <button class="btn  dropdown-toggle text-white" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Help
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <option class="p-2"  (click)="openModal(helpdeskTicketModal)" >Submit a ticket</option>
            <option class="p-2"   value="fr">Knowledgebasse/Manuals</option>
          </div>
        </div>

        <div class=" pt-2 m-1 ">
            
          <i class="fa fa-globe fa-1x mr-2 text-white p-1 " ><select class="mx-2 p-1 text-white" style="background-color: transparent;" #lang (change)="changeLanguage(lang.value)">
              <option (click)="changeLanguage('en')" value="en">EN</option>
              <option (click)="changeLanguage('fr')" value="fr">FR</option>
            
              <option (click)="changeLanguage('es')" value="es">ES</option>
            </select></i>
       </div>



        <div class="dropdown mt-2">
          <button class="btn " id="userDropdown" data-toggle="dropdown" aria-expanded="false" aria-label="User Settings">
            <div class="initials-circle">{{ nameInitials }}</div>
          </button>
          <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
            <li class="">  <a class="dropdown-item " href="#" style="color: #003366; font-weight: bolder;">{{this.username}}</a><a class="dropdown-item text-center w-100" style="font-size: small;">{{role}}</a></li>
            <hr>

            <li><a class="dropdown-item" href="#" (click)=openPasswordResetModal(currentUser,passwordResetModal) translate>Password Reset</a></li>
            <li><a class="dropdown-item" href="#" (click)="logout()">Logout</a></li>
          </ul>
        </div>


  </div>
</div>



<!-- Mobile User Dropdown -->
<div class="dropdown d-lg-none ml-2">
  <button class="btn text-white" id="threeDotsMenu" data-toggle="dropdown" aria-expanded="false" aria-label="User Settings">
    <div class="initials-circle">{{ nameInitials }}</div>
  </button>
  
  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="threeDotsMenu">
    <!-- Username and Role Display -->
    <li class="list-unstyled">
      <a class="dropdown-item" href="#" style="color: #003366; font-weight: bolder;">{{ username }}</a>
      <a class="dropdown-item text-center w-100" style="font-size: small;">{{ role }}</a>
    </li>
    <hr>

    <!-- Password Reset and Logout -->
    <a class="dropdown-item" href="#" (click)="openPasswordResetModal(currentUser, passwordResetModal)" translate>Password Reset</a>
    <a class="dropdown-item" href="#" (click)="logout()">Logout</a>
    <hr>

    <!-- Nested Help Dropdown without Bootstrap Toggle -->



    <div class="dropdown-item d-flex align-items-center">
      <i class="fa fa-info-circle fa-1x mr-2 "></i>
      <select class="form-control p-1 border-0 w-100"  #lang (click)="$event.stopPropagation()" (change)="changeLanguage($event.target.value)">
      
        <option class="p-0" value="" selected>Help</option>
        <option (click)="openModal(helpdeskTicketModal)">Submit a ticket</option>
        <option value="es">Knowledgebase/Manuals</option>
      </select>
    </div>


    <!-- Language Selector -->
    <div class="dropdown-item d-flex align-items-center">
      <i class="fa fa-globe fa-1x mr-2"></i>
      <select class="form-control p-1 border-0" #lang (click)="$event.stopPropagation()" (change)="changeLanguage($event.target.value)">
        <option value="en">EN</option>
        <option value="fr">FR</option>
        <option value="es">ES</option>
      </select>
    </div>
  </div>
</div>
  </nav>
    <!--<nav *ngIf="role!='Device'" class="navbar navbar-fixed-top navbar-expand-lg navbar-light w-100 p-2 " style="background:black; height: 80px; position:static;">

        <ul class="navbar-nav " style="margin-inline-end: auto; padding-inline-start:2px;" >
           
            <img class="navbar-brand" style="height: 25%; width: 25%; font-family: DINPro; "  src="./assets/logo2020w.png"  alt="logo" >
           
     </ul>


<div class="row">

    

         <div class="row mt-2 mr-2 text-white" style="font-family: DinPro; ">
            
            <i class="fa fa-globe fa-1x"><select class="mx-2  text-white" style="font-family: DINPro; background-color: black;" #lang (change)="changeLangage(lang.value)">
                <option (click)="changeLangage('en')" value="en">EN</option>
                <option (click)="changeLangage('fr')" value="fr">FR</option>
              
                <option (click)="changeLangage('es')" value="es">ES</option>
              </select></i>
         </div>


     
        <ul class="navbar-nav ml-auto nav-flex-icons  list-group-horizontal">

       

    
            <li class="dropdown show " *ngIf="currentUser!=null">
       
                    <div class="dropdown show left  ">
                        <a class="btn  d    ropdown-toggle text-white" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-user text-white"></i>
                        </a>
                      
                        <div class="dropdown-menu dropdown-menu-right rounded py-1" style="font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif; font-weight: bold;" aria-labelledby="dropdownMenuLink" >
                          <a class="dropdown-item" style="cursor: pointer;" translate>Settings</a>
                          <a class="dropdown-item" style="cursor: pointer;" (click)=openPasswordResetModal(currentUser,passwordResetModal) translate>Password Reset</a>
 
                          <a class="dropdown-item" style="cursor: pointer;" (click)=logout(); translate>Logout</a>
                          
                        </div>
                      </div>

                
               

            </li>

         

            <li class="nav-item text-white" *ngIf="currentUser==null">
                <a class="nav-link waves-effect waves-light text-white">
                    <div class="d-flex  justify-content-end ">

                        <div class="col-auto pl-2 pr-0 " style="font-size:12px"  routerLink="/login"> Login</div>
                        <div class="col-auto  pl-1" style="font-size:12px"><i class="fa fa-lock"></i></div>
                    </div>
                </a>
            </li> 
     



        </ul>


    </div>
    </nav>-->


    
<!-----------Helpdesk Ticket Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #helpdeskTicketModal let-modal>

    <div class="card">
      <div class="card-header text-white" style="background-color: #132a42;">
        <h5>Create a Ticket</h5>
      </div>
      <div class="card-body">
        <form [formGroup]="ticketForm" (ngSubmit)="onTicketSubmit()">
          <!-- Personal Information -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="name" class="form-label">Full Name *</label>
              <input 
                type="text" 
                class="form-control" 
                id="name" 
                formControlName="name"
                [ngClass]="{'is-invalid': submitted && f.name.errors}"
              >
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">Name is required</div>
              </div>
            </div>
            <div class="col-md-6">
              <label for="email" class="form-label">Email *</label>
              <input 
                type="email" 
                class="form-control" 
                id="email" 
                formControlName="email"
                [ngClass]="{'is-invalid': submitted && f.email.errors}"
              >
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">Email must be valid</div>
              </div>
            </div>
          </div>
  
          <!-- Ticket Details -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="issueType" class="form-label">Issue Type *</label>
              <select 
                class="form-control form-select select2tag select2-hidden-accessible" 
                id="issueType" 
                formControlName="issueType"
                [ngClass]="{'is-invalid': submitted && f.issueType.errors}"
              >
                <option value="">-- Select Issue Type --</option>
                <option value="booking_error">Booking Error</option>
                <option value="cancellation_issue">Cancellation Issue</option>
                <option value="payment_problem">Payment Problem</option>
                <option value="schedule_conflict">Schedule Conflict</option>
                <option value="system_error">System Error</option>
                <option value="other">Other</option>
              </select>
              <div *ngIf="submitted && f.issueType.errors" class="invalid-feedback">
                <div *ngIf="f.issueType.errors.required">Issue type is required</div>
              </div>
            </div>
            <div class="col-md-6">
              <label for="priority" class="form-label">Priority *</label>
              <select 
                class="form-control form-select select2tag select2-hidden-accessible" 
                id="priority" 
                formControlName="priority"
                [ngClass]="{'is-invalid': submitted && f.priority.errors}"
              >
                <option value="">-- Select Priority --</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="critical">Critical</option>
              </select>
              <div *ngIf="submitted && f.priority.errors" class="invalid-feedback">
                <div *ngIf="f.priority.errors.required">Priority is required</div>
              </div>
            </div>
          </div>
  
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="appointmentId" class="form-label">Appointment ID (if applicable)</label>
              <input 
                type="text" 
                class="form-control" 
                id="appointmentId" 
                formControlName="appointmentId"
              >
            </div>
            <div class="col-md-6">
              <label for="appointmentDate" class="form-label">Appointment Date (if applicable)</label>
              <input 
                type="date" 
                class="form-control" 
                id="appointmentDate" 
                formControlName="appointmentDate"
              >
            </div>
          </div>
  
          <div class="mb-3">
            <label for="issueDescription" class="form-label">Issue Description *</label>
            <textarea 
              class="form-control" 
              id="issueDescription" 
              rows="4" 
              formControlName="issueDescription"
              [ngClass]="{'is-invalid': submitted && f.issueDescription.errors}"
            ></textarea>
            <div *ngIf="submitted && f.issueDescription.errors" class="invalid-feedback">
              <div *ngIf="f.issueDescription.errors.required">Issue description is required</div>
              <div *ngIf="f.issueDescription.errors.minlength">Description must be at least 20 characters</div>
            </div>
          </div>
  
          <div class="mb-4">
            <label for="attachments" class="form-label">Attachments (Optional)</label>
            <input 
              type="file" 
              class="form-control pb-5" 
              id="attachments" 
              multiple
              (change)="onFileChange($event)"
            >
            <div class="form-text">You can upload screenshots or related files (max 5MB each)</div>
          </div>
  
          <div class="form-check mb-3">
            <input 
              class="form-check-input" 
              type="checkbox" 
              id="urgentFlag" 
              formControlName="urgentFlag"
            >
            <label class="form-check-label" for="urgentFlag">
              Flag as urgent (requires immediate attention)
            </label>
          </div>
  
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-secondary mr-md-2" (click)="modal.dismiss()" >Cancel</button>
            <button type="submit" *ngIf="!loading" class="btn btn-primary ">Submit Ticket</button>
            <!-- <span *ngIf="loading" class="spinner"></span> -->
          </div>
        </form>
      </div>
    </div>
  <!-- Backdrop with spinner when loading -->
<div *ngIf="loading" class="loading-backdrop">
  <div class="spinner"></div> <!--The spinner inside the backdrop -->
</div>
    <!-- Success Modal -->
    <button id="openTicketSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#ticketSuccessModal">Open Modal</button>
    <div class="modal fade" id="ticketSuccessModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header  text-white" style="background-color: #132a42;">
            <h5 class="modal-title">Ticket Submitted</h5>
            <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
             </button>
          </div>
          <div class="modal-body">
            <p>Your ticket has been submitted successfully. Ticket ID: <strong>{{ ticketId }}</strong></p>
            <p>We will contact you soon regarding this issue.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary"  (click)="modal.dismiss()" >Close</button>
          </div>
        </div>
      </div>
    </div>
 </ng-template>


    
    
<!-----------Password Reset Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #passwordResetModal let-modal>
    <div class="modal-header">
     <h5 class="modal-title" id="statuLabel">Password Reset</h5>
     <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="passwordResetForm" >
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
       <label for="userName" class="col-sm-4 col-form-label font-weight-bold">User Name</label>
       <div class="col-sm-8">
        <input type="text" disabled class="form-control bg-white border-0" formControlName="userName" id="userName">
       </div>
      </div>
      <div class="form-group row">
       <label for="name" class="col-sm-4 col-form-label font-weight-bold"> Name</label>
       <div class="col-sm-8">
        <input type="text" disabled class="form-control bg-white border-0" formControlName="fullName" id="fullName">
       </div>
      </div>
      <div class="form-group row">
       <label for="status" class="col-sm-4 col-form-label font-weight-bold"> Status</label>
       <div class="col-sm-8">
        <input type="text" disabled class="form-control bg-white border-0" formControlName="currentStatus" id="currentStatus">
       </div>
      </div>
  
      <div class="form-group row">
        <label for="password" class="col-sm-4 col-form-label font-weight-bold"> New Password</label>
        <div class="col-sm-8">
         <input type="text" type="password" class="form-control bg-white " [class.is-invalid]="formErrors.password" (blur)="logValidationErrors(passwordResetForm)" formControlName="password">
         <div class=" pb-2  text-danger"
         [class.d-none]="!formErrors.password">
         <small>{{formErrors.password}}</small></div>
  
         
        </div>
       </div>
  
  
       <div class="form-group row">
        <label for="confirmPassword" class="col-sm-4 col-form-label font-weight-bold"> Confirm Password</label>
        <div class="col-sm-8">
         <input type="text" type="password" class="form-control bg-white " [class.is-invalid]="formErrors.confirmPassword" (blur)="logValidationErrors(passwordResetForm)" formControlName="confirmPassword" id="confirmPassword">
        
        <div class=" pb-2 text-danger"
        [class.d-none]="!formErrors.confirmPassword">
        <small>{{formErrors.confirmPassword}}</small></div>
    </div>
        
       </div>
  
  
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
       <button type="submit" class="btn btn-primary"  [disabled]='!passwordResetForm.valid || !passwordResetForm.valid'  (click)=submitPasswordReset();>Confirm</button>
      </div>
     </form>
    </div>
   </ng-template>
  
  
      
      
  
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" data-backdrop="false" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">



                                <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">Your changes has been saved.</h4>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" (click)="refreshWindow()" data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                       Error Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" data-backdrop="false" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger">ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" routerLink='/assets' data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>





    <!DOCTYPE html style="width:600px;">
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>CiotChat</title>
    <link rel="icon" type="image/x-icon" href="https://ciot.com/pub/media/logo/default/logo-ciot.png">
    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>

</head>

<body style="text-align: left">
 <!--   <iframe id="IFrame" [src]="iframeSrc" width="600" top="100"  allow="camera;microphone"></iframe>
<iframe id="rcChannel" name="rcChannel" src="https://ciotchat.dart-it.com/?layout=embedded"  style="height:100%;border:none !important; width:100%;overflow:hidden;position: absolute; top: 0;left: 0;bottom: 0;right: 0;"></iframe>-->
<script>
    let d,p,c,totalunread = 0;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const username = urlParams.get('username');
const password = urlParams.get('password');
let resultjson;

let postObj = { 
    user: username, 
    password: password
}

let post = JSON.stringify(postObj);
//console.log(post);


fetch("https://ciotchat.dart-it.com/api/v1/login/", {
    method: 'post',
    body: post,
    headers: {
        'Content-Type': 'application/json'
    }
}).then((response) => {
   // console.log("saving response");
    var responsed = response.clone();
return response.json()

}).then((res) => {

    if (res.status === 'error') {
        console.log("NO USER!");
        var email = username+'@ciotchat.dart-it.com';
        var name = username;
        console.log('username to register =  '+username );
        console.log('password to register =  '+password );
        console.log('email to register =  '+email );
        console.log('name to register =  '+name);
        
let rpostObj = { 
    username: username, 
    email: email,
    pass:password,
    name:name
}
  let rpost = JSON.stringify(rpostObj);
     // console.log(rpost);
        

  $.post("https://ciotchat.dart-it.com/api/v1/users.register",
  {
    username: username, 
    email: email,
    pass:password,
    name:name
  },
  function(data, status){
 // console.log("Data: " + data + "\nStatus: " + status);
  
    $.post("https://ciotchat.dart-it.com/api/v1/login/",
  {
    user: username, 
    password:password
  },
  function(data, status){
      var token2 = JSON.stringify(data);
      var obj = JSON.parse(token2);

      //console.log(obj.data.authToken);
 
  
  var token2 = obj.data.authToken;
  window.onload = function () {
        authenticateIFrame(token2);
    };
  
  });
  
  
  });

        
        
       // var token = res.authToken;
    }
    
    
    else{
        
    //console.log(res.data.authToken);
    var token = res.data.authToken;
    
 window.onload = function () {
        authenticateIFrame(token);
    };
    
    
    }
}).catch((error) => {
   // console.log(error);
            console.log("SORRY!");

})

 

function authenticateIFrame(token) {
   // console.log("in iframe post message");
   // console.log(token);
document.getElementById('rcChannel').contentWindow.postMessage(
{      
  event: 'login-with-token',
  loginToken: token
}, '*');

//console.log("giving token    "+token);

authenticateIFrame2(token);
    
}

function authenticateIFrame2(token) {
    setTimeout(
        function(){
    //console.log("in iframe post message 2");
   // console.log(token);
document.getElementById('rcChannel').contentWindow.postMessage(
{      
  externalCommand: 'login-with-token',
  token: '@token'
}, '*');

//console.log("giving token 2   "+token);


	if(!window.location.hash) {
		window.location = window.location + '#loaded';
		//console.log("reloading");
		window.location.reload();
	
}

}, 2000);
             p=0;
             d=0;
             c=0;
}
    
     window.addEventListener('message', function(event) {
       var i =event.data;
              const myJSON = JSON.stringify(i);
         var j = JSON.parse(myJSON);
         //var totalunread = j
        // console.log(j.eventName);
        // console.log(j);
         
         
         if(j.eventName == "unread-changed"){
             
             if(isNaN(totalunread) || totalunread == j.data){
                              console.log("No New Message");

             }
         
      else{
          totalunread =  j.data;
                      console.log("Total Unread Messages: " + totalunread );
       console.log("Total Direct Messages: " + d);
       console.log("Total Team Messages: " + p);
console.log("Total Channel Messages: " + c);

          //  p=0;
          //   d=0;
           //  c=0;
          
         }
         
         }
         
         
         
         if(j.eventName == "unread-changed-by-subscription"){
             if(j.data.unread >0){
                
                
             
                   //  console.log(j);

            const twojp = j.data.t;
//console.log(twojp);
  if(twojp == "d"){
      d= d+ j.data.unread;
      // console.log("Total Direct Messages: " + d);
       }
     if(twojp == "p"){
         p=p+j.data.unread;
      // console.log("Total Team Messages: " + p);
       }
     if(twojp == "c"){
          c=c+j.data.unread;
//console.log("Total Channel Messages: " + c);
       }
    
  
            }   
            
            
            
            }
     //  
//   // console.log("Message received from the parent: " + myJSON);
   // Message received from parent
  });



</script>
</body>
</html>